(function () {
  'use strict';

  if (window.EnhancedLandingPageInit) return;
  window.EnhancedLandingPageInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  function init(scope) {
    var root = scope || document;
    qsa('[data-faq] [data-faq-item]', root).forEach(faqItem);
    qsa('[data-tabs]', root).forEach(tabs);
    qsa('[data-gallery]', root).forEach(gallery);
    qsa('[data-carousel]', root).forEach(carousel);
    qsa('[data-slider]', root).forEach(slider);
    qsa('[data-stepper]', root).forEach(stepper);
    qsa('[data-plan-picker]', root).forEach(planPicker);
    qsa('[data-dose-picker]', root).forEach(dosePicker);
    qsa('[data-collection-filter]', root).forEach(collectionFilter);
    qsa('[data-mobile-menu-toggle]', root).forEach(mobileMenuToggle);
    qsa('[data-page-picker]', root).forEach(pagePicker);
    revealMotion(root);
    navMotion(root);
  }

  // ── helpers ──────────────────────────────────────────────────
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { el.addEventListener(ev, fn); }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function noRevealPage() { return document.body.classList.contains('lp-theme--light-authority'); }

  // ── Premium scroll reveals ───────────────────────────────────
  function revealMotion(root) {
    if (noRevealPage()) return;

    var selector = [
      '.eg-display',
      '.eg-body',
      '.eg-btn',
      '.eg-gallery-stage',
      '.eg-gallery-thumb',
      '.eg-offer-bullets li',
      '.eg-offer-trust-cell',
      '.eg-offer-gift',
      '.eg-tabbar button',
      '.eg-tab-panel .eg-grid > *',
      '.eg-ing-card',
      '.eg-athletes-quote-stage',
      '.eg-ugc-tile',
      '.eg-review-card',
      '.eg-cmp-row',
      '.eg-tline-row',
      '.eg-advisor',
      '.eg-gtee',
      '.eg-offer-row'
    ].join(',');
    var elements = qsa(selector, root).filter(function (el) {
      return !el.dataset.revealInit && el.closest('.shopify-section');
    });

    if (!elements.length) return;
    elements.forEach(function (el, index) {
      el.dataset.revealInit = 'true';
      el.classList.add('eg-reveal');
      el.style.setProperty('--eg-stagger', String(Math.min(index % 8, 7)));
    });

    if (reducedMotion() || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!window.EnhancedLandingPageRevealObserver) {
      window.EnhancedLandingPageRevealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    }

    elements.forEach(function (el) {
      window.EnhancedLandingPageRevealObserver.observe(el);
    });
  }

  // ── Sticky LP nav polish ─────────────────────────────────────
  function navMotion(root) {
    var navs = qsa('.eg-lp-nav', root);
    if (!navs.length && root.matches && root.matches('.eg-lp-nav')) navs = [root];
    if (!navs.length || window.EnhancedLandingPageNavMotion) return;
    window.EnhancedLandingPageNavMotion = true;

    function update() {
      qsa('.eg-lp-nav').forEach(function (nav) {
        nav.classList.toggle('is-scrolled', window.scrollY > 12);
      });
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  // ── FAQ accordion ────────────────────────────────────────────
  // <div data-faq>
  //   <div data-faq-item> <button data-faq-toggle>...</button> <div data-faq-body>...</div> </div>
  // </div>
  function faqItem(item) {
    var toggle = qs('[data-faq-toggle]', item);
    var faq = item.closest('[data-faq]');
    if (!toggle || item.dataset.faqInit) return;
    item.dataset.faqInit = 'true';

    function closeItem(openItem) {
      var openToggle = qs('[data-faq-toggle]', openItem);
      openItem.classList.remove('is-open');
      if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
    }

    if (item.classList.contains('is-open') && faq) {
      qsa('[data-faq-item].is-open', faq).forEach(function (openItem) {
        if (openItem !== item && openItem.dataset.faqInit) closeItem(openItem);
      });
    }

    on(toggle, 'click', function () {
      var willOpen = !item.classList.contains('is-open');

      if (willOpen && faq) {
        qsa('[data-faq-item].is-open', faq).forEach(function (openItem) {
          if (openItem !== item) closeItem(openItem);
        });
      }

      item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
    });
  }

  // ── Tabs ─────────────────────────────────────────────────────
  // <div data-tabs>
  //   <div data-tab-list>
  //     <button data-tab="0">…</button>  <button data-tab="1">…</button>
  //   </div>
  //   <div data-tab-panel="0">…</div>     <div data-tab-panel="1">…</div>
  // </div>
  function tabs(root) {
    var buttons = qsa('[data-tab]', root);
    var panels = qsa('[data-tab-panel]', root);
    function show(idx) {
      buttons.forEach(function (b) {
        var isActive = b.dataset.tab === String(idx);
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var isActive = p.dataset.tabPanel === String(idx);
        p.classList.toggle('is-active', isActive);
        if (isActive) {
          qsa('[data-slider]', p).forEach(function (track) {
            track.scrollLeft = 0;
          });
        }
      });
    }
    buttons.forEach(function (b) {
      on(b, 'click', function () { show(b.dataset.tab); });
    });
    show(0);
  }

  // ── Image gallery (offer hero, PDP) ──────────────────────────
  // <div data-gallery data-gallery-count="N">
  //   <div data-gallery-stage>
  //     <img data-gallery-image src="..." />
  //   </div>
  //   <button data-gallery-prev>…</button>
  //   <button data-gallery-next>…</button>
  //   <div data-gallery-dots> <span data-gallery-dot="0"></span> … </div>
  //   <div data-gallery-thumbs>
  //     <button data-gallery-thumb="0" data-src="..."></button> …
  //   </div>
  // </div>
  function gallery(root) {
    var thumbs = qsa('[data-gallery-thumb]', root);
    var image = qs('[data-gallery-image]', root);
    var dots = qsa('[data-gallery-dot]', root);
    var srcs = thumbs.map(function (t) { return t.dataset.src; });
    var idx = 0;

    function show(i) {
      idx = (i + srcs.length) % srcs.length;
      if (image) image.src = srcs[idx];
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === idx); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
    }

    thumbs.forEach(function (t, j) { on(t, 'click', function () { show(j); }); });
    var prev = qs('[data-gallery-prev]', root);
    var next = qs('[data-gallery-next]', root);
    if (prev) on(prev, 'click', function () { show(idx - 1); });
    if (next) on(next, 'click', function () { show(idx + 1); });

    show(0);
  }

  // ── Carousel (athlete testimonials, reviews, UGC) ────────────
  // <div data-carousel>
  //   <div data-carousel-track>
  //     <div data-carousel-slide>…</div> …
  //   </div>
  //   <span data-carousel-counter></span>
  //   <button data-carousel-prev>…</button>
  //   <button data-carousel-next>…</button>
  // </div>
  function carousel(root) {
    var slides = qsa('[data-carousel-slide]', root);
    var bgSlides = qsa('[data-carousel-bg-slide]', root);
    var counters = qsa('[data-carousel-counter]', root);
    var idx = 0;

    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
      bgSlides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
      counters.forEach(function (counter) {
        counter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      });
    }

    qsa('[data-carousel-prev]', root).forEach(function (prev) {
      on(prev, 'click', function () { show(idx - 1); });
    });
    qsa('[data-carousel-next]', root).forEach(function (next) {
      on(next, 'click', function () { show(idx + 1); });
    });

    show(0);
  }

  // ── Horizontal slider (UGC, review cards) ───────────────────
  function slider(track) {
    if (track.dataset.sliderInit === 'true') return;
    track.dataset.sliderInit = 'true';

    var scope = track.closest('[data-slider-scope]') || track.closest('section') || track.parentElement;
    var prev = scope ? qs('[data-slider-prev]', scope) : null;
    var next = scope ? qs('[data-slider-next]', scope) : null;
    var dotsContainer = scope ? qs('[data-slider-dots]', scope) : null;
    var dots = dotsContainer ? qsa('[data-slider-dot]', dotsContainer) : [];
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragged = false;

    function slides() {
      return Array.from(track.children).filter(function (child) {
        return child.getBoundingClientRect().width > 0;
      });
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function currentIndex(items) {
      var list = items || slides();
      if (!list.length) return 0;
      var current = 0;
      var closest = Infinity;
      list.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (distance < closest) {
          closest = distance;
          current = index;
        }
      });
      return current;
    }

    function scrollToIndex(index, behavior) {
      var items = slides();
      var max = maxScroll();
      if (!items.length) return;
      var safeIndex = Math.max(0, Math.min(index, items.length - 1));
      var target = Math.min(items[safeIndex].offsetLeft, max);
      track.scrollTo({ left: target, behavior: behavior || 'smooth' });
    }

    function updateDots(index) {
      if (!dots.length) return;
      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function move(direction) {
      var items = slides();
      var max = maxScroll();
      if (!items.length) return;
      if (max <= 0) return;
      var index = currentIndex(items);
      var nextIndex = index + direction;
      if (nextIndex >= items.length) nextIndex = 0;
      if (nextIndex < 0) nextIndex = items.length - 1;
      scrollToIndex(nextIndex);
    }

    if (prev) on(prev, 'click', function () { move(-1); });
    if (next) on(next, 'click', function () { move(1); });
    dots.forEach(function (dot, index) {
      on(dot, 'click', function () { scrollToIndex(index); });
    });

    on(track, 'pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      isDragging = true;
      dragged = false;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });

    on(track, 'pointermove', function (event) {
      if (!isDragging) return;
      var delta = event.clientX - dragStartX;
      if (Math.abs(delta) > 3) dragged = true;
      track.scrollLeft = dragStartScroll - delta;
    });

    function endDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      var items = slides();
      var index = currentIndex(items);
      scrollToIndex(index);
      updateDots(index);
      setTimeout(function () { dragged = false; }, 0);
    }

    on(track, 'pointerup', endDrag);
    on(track, 'pointercancel', endDrag);
    on(track, 'scroll', function () {
      if (isDragging || !dots.length) return;
      updateDots(currentIndex());
    }, { passive: true });
    updateDots(0);
    on(track, 'click', function (event) {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
    });
  }

  // ── Quantity stepper ─────────────────────────────────────────
  function stepper(root) {
    var display = qs('[data-stepper-display]', root);
    var minus = qs('[data-stepper-minus]', root);
    var plus = qs('[data-stepper-plus]', root);
    var qty = 1;
    function update() { if (display) display.textContent = qty; }
    if (minus) on(minus, 'click', function () { qty = Math.max(1, qty - 1); update(); });
    if (plus) on(plus, 'click', function () { qty = qty + 1; update(); });
    update();
  }

  // ── Plan picker (subscribe vs one-time on PDP) ───────────────
  // <div data-plan-picker>
  //   <button data-plan="sub" class="is-active">…</button>
  //   <button data-plan="one">…</button>
  // </div>
  function planPicker(root) {
    var btns = qsa('[data-plan]', root);
    btns.forEach(function (b) {
      on(b, 'click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
  }

  // ── Dose picker (segmented buttons on PDP) ───────────────────
  function dosePicker(root) {
    var btns = qsa('[data-dose]', root);
    btns.forEach(function (b) {
      on(b, 'click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
  }

  // ── Collection filter (sex pills + tag pills) ────────────────
  function collectionFilter(root) {
    var groups = qsa('[data-filter-group]', root);
    var items = qsa('[data-filter-item]', root);
    var state = {};
    groups.forEach(function (g) {
      state[g.dataset.filterGroup] = g.dataset.filterDefault || 'all';
      qsa('[data-filter-value]', g).forEach(function (b) {
        on(b, 'click', function () {
          state[g.dataset.filterGroup] = b.dataset.filterValue;
          qsa('[data-filter-value]', g).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          apply();
        });
      });
    });
    function apply() {
      var visible = 0;
      items.forEach(function (it) {
        var keep = true;
        Object.keys(state).forEach(function (k) {
          var v = state[k];
          if (v === 'all') return;
          var tags = (it.dataset['filter' + cap(k)] || '').split(',').map(function (s) { return s.trim(); });
          if (!tags.includes(v)) keep = false;
        });
        it.style.display = keep ? '' : 'none';
        if (keep) visible++;
      });
      var counter = qs('[data-filter-count]', root);
      if (counter) counter.textContent = visible;
    }
    apply();
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  // ── Mobile nav toggle (hamburger reveals drawer) ─────────────
  function mobileMenuToggle(btn) {
    var drawer = qs('[data-mobile-menu]');
    on(btn, 'click', function () {
      var open = document.body.classList.toggle('eg-menu-open');
      btn.setAttribute('aria-expanded', open);
      if (drawer) drawer.classList.toggle('is-open', open);
    });
    qsa('[data-mobile-menu-close]').forEach(function (el) {
      on(el, 'click', function () {
        document.body.classList.remove('eg-menu-open');
        btn.setAttribute('aria-expanded', 'false');
        if (drawer) drawer.classList.remove('is-open');
      });
    });
  }

  // ── Page picker (prototype navigation pill) ──────────────────
  function pagePicker(root) {
    var btn = qs('[data-page-picker-btn]', root);
    var menu = qs('[data-page-picker-menu]', root);
    if (!btn || !menu) return;
    on(btn, 'click', function () {
      menu.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) menu.classList.remove('is-open');
    });
  }
})();
